<script setup>
import GoogleAdsSearchTermInsightTable from "@frontJs/components/tables/projectManagement/seo/GoogleAdsSearchTermInsightTable.vue";
import TenantTrackingPositionTable from "@frontJs/components/tables/projectManagement/seo/TenantTrackingPositionTable.vue";
import TrackedKeywordTable from "@frontJs/components/tables/projectManagement/seo/TrackedKeywordTable.vue";
import TrackingPositionTable from "@frontJs/components/tables/projectManagement/seo/TrackingPositionTable.vue";
import ProjectManagementLayout from "@frontJs/layouts/ProjectManagementLayout.vue";
import { Head } from "@inertiajs/vue3";
import TabGroup from "@js/components/tabs/TabGroup.vue";
import TabPanel from "@js/components/tabs/TabPanel.vue";
import PageTitle from "@js/components/titles/PageTitle.vue";
import { ref } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const { tenant, websiteVariants, targetedLanguages, targetableGoogleWebsites } =
  defineProps({
    tenant: {
      type: Object,
      required: false,
    },
    websiteVariants: {
      type: Array,
      required: true,
    },
    targetedLanguages: {
      type: Array,
      required: true,
    },
    targetableGoogleWebsites: {
      type: Array,
      required: true,
    },
  });

const selectedTab = ref(0);

function changeTab(index) {
  selectedTab.value = index;
}

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
  <Head v-if="tenant">
    <title>
      {{ tenant.name }} - {{ t("title.positionTracking") }} -
      {{ t("title.seo") }} - {{ t("title.projectManagement") }} -
      {{ t("title.datakepler") }}
    </title>
  </Head>

  <Head v-else>
    <title>
      {{ t("title.positionTracking") }} - {{ t("title.seo") }} -
      {{ t("title.projectManagement") }} - {{ t("title.datakepler") }}
    </title>
  </Head>

  <PageTitle v-if="tenant">
    {{ t("title.projectManagement") }} - {{ t("title.seo") }} -
    {{ t("title.positionTracking") }} - {{ tenant.name }}
  </PageTitle>

  <PageTitle v-else>
    {{ t("title.projectManagement") }} - {{ t("title.seo") }} -
    {{ t("title.positionTracking") }}
  </PageTitle>

  <TabGroup
    v-if="tenant"
    :selected-tab="selectedTab"
    :change-tab="changeTab"
    :tabs="{
      positions: t('title.positions'),
      keywords: t('title.keywords'),
      seaKeywords: t('title.seaKeywords'),
    }"
  >
    <template #panels>
      <TabPanel without-background unmount>
        <TrackingPositionTable :tenant="tenant" />
      </TabPanel>

      <TabPanel without-background unmount>
        <TrackedKeywordTable
          :tenant="tenant"
          :website-variants="websiteVariants"
          :targeted-languages="targetedLanguages"
          :targetable-google-websites="targetableGoogleWebsites"
        />
      </TabPanel>

      <TabPanel without-background unmount>
        <GoogleAdsSearchTermInsightTable
          :tenant="tenant"
          :website-variants="websiteVariants"
          :targeted-languages="targetedLanguages"
          :targetable-google-websites="targetableGoogleWebsites"
        />
      </TabPanel>
    </template>
  </TabGroup>

  <TenantTrackingPositionTable v-else />
</template>
